import { render, staticRenderFns } from "./CustomerModal.vue?vue&type=template&id=0c9087b9&scoped=true&lang=pug"
import script from "./CustomerModal.vue?vue&type=script&lang=js"
export * from "./CustomerModal.vue?vue&type=script&lang=js"
import style0 from "./CustomerModal.vue?vue&type=style&index=0&id=0c9087b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9087b9",
  null
  
)

export default component.exports